// export const API_URL = 'https://api.praktekdokterbob.com/api_drbobsclinic/api';
// export const LOGIN_URL =
//   'https://api.praktekdokterbob.com/api_drbobsclinic/api/auth/login';
export const API_URL = `https://dev.api.praktekdokterbob.com/api`;
export const LOGIN_URL = "https://dev.api.praktekdokterbob.com/api/auth/login";
